// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"p_-z","narrowOptionButtons":"q_-z","noOptions":"r_-z"};